import React, { useEffect } from 'react';
import * as S from './styles_M.Franquia';
import MaskedInput from 'react-text-mask';

export function ModalAddFranquia({ 
    isOpen, 
    onClose, 
    franquia, 
    SetFranquia, 
    foneCelular, 
    SetCelularFranquia,
    AddFranquia,
}) {
    // -------------------------------
    
      if (!isOpen) return null;
    
    // -------------------------------

    // ###############################################################
    return (
        <S.ModalOverlay onClick={onClose}>
            <S.ModalContainer onClick={(e) => e.stopPropagation()}>
                <S.ModalHeader>
                    <S.ModalTitle>Novo Representante</S.ModalTitle>
                    <S.CloseButton onClick={onClose}>✕</S.CloseButton>
                </S.ModalHeader>

                <S.ModalContent>
                    <div style={{ display: "flex", width: "100%", gap: "5px" }}>
                        {franquia.cpfCnpj?.length <= 11 ?
                            <div className='listaFlexCol' style={{ minWidth: "100px" }}>
                                <span style={{ color: "yellow" }}>CPF:</span>
                                <MaskedInput
                                    value={franquia.cpfCnpj}
                                    type='text'
                                    placeholder='cpf/cnpj'
                                    mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]}
                                    onChange={e => SetFranquia("cpfCnpj", e.target.value.replace(/\D/gim, ''))}
                                    guide={false}
                                />
                            </div>
                            :
                            <div className='listaFlexCol' style={{ minWidth: "100px" }}>
                                <span style={{ color: "yellow" }}>CNPJ:</span>
                                <MaskedInput
                                    value={franquia.cpfCnpj}
                                    type='text'
                                    placeholder='cpf/cnpj'
                                    mask={[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                                    onChange={e => SetFranquia("cpfCnpj", e.target.value.replace(/\D/gim, ''))}
                                    guide={false}
                                />
                            </div>
                        }
                        
                        <div className='listaFlexCol' style={{ minWidth: "150px" }}>
                            <span style={{ color: "yellow" }}>Novo Representante:</span>
                            <input
                            disabled={franquia.cpfCnpj.length < 11}
                            value={franquia.nome}
                            className='maiusculo'
                            type='text'
                            placeholder='nome'
                            onChange={e => SetFranquia('nome', e.target.value)}
                            />
                        </div>
                    </div>

                    <div style={{ display: "flex", width: "100%", gap: "5px" }}>
                        <div className='listaFlexCol' style={{ minWidth: "100px" }}>
                            <span style={{ color: "yellow" }}>
                                Cidade:
                            </span>
                            <input
                                style={{ textTransform: "capitalize" }}
                                disabled={franquia.cpfCnpj.length < 11}
                                type="text"
                                placeholder='cidade'
                                value={franquia.cidade}
                                onChange={(e) => SetFranquia("cidade", e.target.value)}
                            />
                        </div>

                        <div className='listaFlexCol' style={{ minWidth: "100px" }}>
                            <span style={{ color: "yellow" }}>
                                Celular:
                            </span>
                            <MaskedInput
                                mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                                type="text"
                                placeholder='celular'
                                disabled={franquia.cpfCnpj.length < 11}
                                value={foneCelular.numeroCel}
                                onChange={(e) => SetCelularFranquia("numeroCel", e.target.value.replace(/\D/gim, ''))}
                                guide={false}
                            />
                        </div>
                    </div>
                </S.ModalContent>

                <S.ModalFooter>
                    <S.ButtonAdd 
                        disabled={!franquia.cpfCnpj || !franquia.nome || !franquia.cidade || !foneCelular.numeroCel}
                        onClick={() => {
                            AddFranquia();
                            onClose();
                        }}
                    >
                        Adicionar
                    </S.ButtonAdd>
                </S.ModalFooter>
            </S.ModalContainer>
        </S.ModalOverlay>
    );
}
